import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import { checkDateRange } from 'utils/helpers';
import { reportDiscountReport } from 'utils/breadcrumbInfo';
import WithRouter from 'custom/withRouter';
import { showError } from 'actions/CommonActions';
import { getDiscountReport, getCsvReport } from 'actions/ReportsAction';
import { formInput, clearFormInput } from 'actions/FormActions';
// Basic Components
import CardSimple from 'screens/components/basic/CardSimple';
import Grid from 'screens/components/basic/Grid';
import KnowledgeBase from 'screens/components/basic/KnowledgeBaseIcon';
import PageHeader from 'screens/components/basic/PageHeader';

import DateCurrentDisplay from 'screens/containers/report/DateCurrentDisplay';
import Body from './Body';
import Header from './Header';
import BranchSummary from './BranchSummary';

const DiscountReport = () => {
    const dispatch = useDispatch();
    const { userBranches, branchId: loggedBranch } = useSelector(state => state.common || {});
    const branchOptions = [];
    userBranches && userBranches.map((item) => {
        branchOptions.push({
            text: item.name, value: item.id.toString()
        });
    })
    const { discountReport } = useSelector(state => state.reports || {});
    const {
        DiscountReportBeginDate: beginDate,
        DiscountReportEndDate: endDate,
        DiscountReportBranchIds: branch,
        DiscountReportEmployeeFirstName: employeeFirstName,
        DiscountReportEmployeeLastName: employeeLastName,
        DiscountReportOrderType: orderType
    } = useSelector(state => state.form || {});
        

    // Local State
    const [activePage, setActivePage] = useState(1);
    const [activePageManual, setActivePageManual] = useState(1);
    const [activePageCustomized, setActivePageCustomized] = useState(1);
    const [activePageCampaign, setActivePageCampaign] = useState(1);
    const [activePageLoyalty, setActivePageLoyalty] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(1000);
    const [showBody, setShowBody] = useState(false);
    const [totalRow, setTotalRow] = useState(0);
    const [tabData, setTabData] = useState({});

    useEffect(() => {
        const date = new Date();
        dispatch(formInput(new Date(date.getFullYear(), date.getMonth(), 1), 'DiscountReportBeginDate'));
        dispatch(formInput(date, 'DiscountReportEndDate'));
    }, []);

    useEffect(() => {
        if (discountReport && discountReport.details){
            let distinctBranches = [... new Set(discountReport.branchSummary.map(item => item.branchId))];
            let branchSummary = []
            distinctBranches.forEach(branch => {
                let singleBranchSummary = discountReport.branchSummary.filter(x => x.branchId === branch);
                
                branchSummary.push({
                    branchName: singleBranchSummary[0].branchName,
                    manual: singleBranchSummary.filter(x => x.orderProductDiscountReason === 1)[0].discounts,
                    customized: singleBranchSummary.filter(x => x.orderProductDiscountReason === 2)[0].discounts,
                    campaign: singleBranchSummary.filter(x => x.orderProductDiscountReason === 3)[0].discounts,
                    loyalty: singleBranchSummary.filter(x => x.orderProductDiscountReason === 4)[0].discounts
                })
            })
    
            const discountReportformatted = {
                details:{
                    manual: discountReport.details.filter(x => x.orderProductDiscountReason === 1),
                    customized: discountReport.details.filter(x => x.orderProductDiscountReason === 2),
                    campaign: discountReport.details.filter(x => x.orderProductDiscountReason === 3),
                    loyalty: discountReport.details.filter(x => x.orderProductDiscountReason === 4),
                    length: discountReport.details.length
                },
                branchSummary,
                summary: {
                    manual: discountReport.summary.filter(x => x.orderProductDiscountReason === 1)[0].discounts,
                    customized: discountReport.summary.filter(x => x.orderProductDiscountReason === 2)[0].discounts,
                    campaign: discountReport.summary.filter(x => x.orderProductDiscountReason === 3)[0].discounts,
                    loyalty: discountReport.summary.filter(x => x.orderProductDiscountReason === 4)[0].discounts
                }
            }
            setTabData(discountReportformatted);
        }
    }, [discountReport]);

    const downloadReport = () => {
        const formattedBeginDate = beginDate ? moment(beginDate).format('YYYY-MM-DD') : moment().add('day').format('YYYY-MM-DD');
        const formattedEndDate = endDate ? moment(endDate).format('YYYY-MM-DD') : moment().add('day').format('YYYY-MM-DD');
        const branchId = branch || loggedBranch;
        const employeeFirst = employeeFirstName || "All";
        const employeeLast = employeeLastName || "All";

        if (checkDateRange(formattedBeginDate, formattedEndDate)) {
            dispatch(showError(LOOKUP.report.common.dateRangeError));
        } else {
            dispatch(getCsvReport(`reports/excel/discountreport?beginDate=${formattedBeginDate}&endDate=${formattedEndDate}&employeeFirstName=${employeeFirst}&employeeLastName=${employeeLast}&branch=${branchId}&orderType=${orderType}`, 'DiscountReport'));
        }
    };
    const filter = () => {
        setActivePage(1);
        setActivePageManual(1);
        setActivePageCustomized(1);
        setActivePageCampaign(1);
        setActivePageLoyalty(1);
        getReport();
    }

    const getReport = () => {
        const formattedBeginDate = beginDate ? moment(beginDate).format('YYYY-MM-DD') : moment().add('day').format('YYYY-MM-DD');
        const formattedEndDate = endDate ? moment(endDate).format('YYYY-MM-DD') : moment().add('day').format('YYYY-MM-DD');
        const branchId = branch.join(",") || loggedBranch;
        let pageNumber = activePage;
        let manualPageNumber = activePageManual;
        let customizedPageNumber = activePageCustomized;
        let campaignPageNumber = activePageCampaign;
        let loyaltyPageNumber = activePageLoyalty;
        let pageSize = itemsPerPage;
        let employeeFirst = employeeFirstName || "All";
        let employeeLast = employeeLastName || "All";
        dispatch(getDiscountReport({ beginDate: formattedBeginDate, endDate: formattedEndDate, employeeFirstName: employeeFirst, employeeLastName: employeeLast, pageNumber, manualPageNumber, customizedPageNumber, campaignPageNumber, loyaltyPageNumber, pageSize, branch: branchId, orderType }));
    }

    const showBodyContent = () => {
        if (checkDateRange(beginDate, endDate)) {
            dispatch(showError(LOOKUP.report.common.dateRangeError));
        } else {
            filter();
            setShowBody(true);
        }
    }

    useEffect(() => {
        if (showBody) {
            const total = discountReport && discountReport.list && discountReport.list.length > 0 ? discountReport.list[0].totalRows : 0;
            setTotalRow(total);
        }
    }, [discountReport, showBody]);

    return (
        <Grid headerContent={reportDiscountReport}>
            <PageHeader title={LOOKUP.report.discountReport.text} description={LOOKUP.report.discountReport.description} icon={<KnowledgeBase link="https://knowledge.techpos.ca/en/knowledge/what-is-the-discount-report" />} />
            <Header
                branchOptions={branchOptions}
                filter={filter}
                download={downloadReport}
                showBody={showBodyContent}
                loggedBranch={loggedBranch}
            />
            {showBody && 
                <React.Fragment>
                    <DateCurrentDisplay />
                    <CardSimple>
                        <Body tabData={tabData} />
                    </CardSimple>
                </React.Fragment>
            }
        </Grid>
    );
}

export default DiscountReport;